<div class="">
  <div class="custella-modal d-flex flex-column">
    <div class="custella-modal-header align-items-center">
      <div class="custella-modal-header-text">
        <span>{{translate?.general.buttons.update.singular}}&nbsp;{{translate?.general.messages.confirmation}}</span>
      </div>
      <i class="fa-regular fa-xmark fa-lg" [pTooltip]="translate?.general.buttons.close.singular" tooltipPosition="left"
        (click)="modelRef.hide()"></i>
    </div>
    <div class="custella-modal-body p-0">
      <div class="custella-form-container box-none m-0">
        
        <div class="custella-content-row mx-3">This will update the components which has this status. Components without this status will not be updated</div>
       
      </div>
    </div>
    <div class="custella-modal-footer flex-align-center justify-content-end">
      <button type="button" class="custella-btn-white text-12 ms-2"
        (click)="modelRef.hide()">{{translate?.general.buttons.cancel.singular}}</button>
      <p-button type="button" [label]="translate?.general.buttons.proceed.singular" styleClass="ms-2 h-32" (onClick)="onSubmit()"></p-button>
    </div>
  </div>
</div>